import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useFetchPlayGameUrl } from "../../hooks/playGame/usePlayGame";
import { request } from "../../hooks/api/fetch";
import { toast } from "react-toastify";

function PlayGameFrame() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const gameID = searchParams.get("id");
  const ccAuth = JSON.parse(sessionStorage.getItem("ccAuth") || "");

  const playGame = useFetchPlayGameUrl({ user_id: ccAuth?.id, id: gameID });

  // modal state
  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");

  const handleSubmitFeedback = async () => {
    const payload = {
      user_id: ccAuth?.id,
      game_id: gameID,
      rating: rating,
      feedback: feedback,
    };

    try {
      const response = await request.post("/games/feedback", payload);
      toast.success(response.message || "Feedback submitted successfully!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error submitting feedback");
    }

    setShowModal(false);
    navigate("/qwiz/homepage");
  };

  if (!gameID || playGame.isError || playGame.data?.success === false) {
    navigate("/qwiz/homepage");
  }

  return (
    <div className="h-[100vh] p-4 flex flex-col justify-center items-center">
      <div className="w-full bg-white p-4 flex justify-end">
        <button
          className="btn btn-error btn-sm max-w-max"
          onClick={() => setShowModal(true)}
        >
          X
        </button>
      </div>

      <iframe
        src={playGame.data?.data?.filePath}
        title="gameplay frame"
        className="w-full h-[90%]"
      />

      {/* Feedback Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40  px-4  flex sm:justify-center items-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full sm:w-96">
            <h2 className="text-xl font-semibold mb-4">Rate the Game</h2>

            {/* Rating */}
            <div className="flex gap-2 mb-4">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  className={`text-2xl ${
                    rating >= star ? "text-yellow-400" : "text-gray-300"
                  }`}
                  onClick={() => setRating(star)}
                >
                  ★
                </button>
              ))}
            </div>

            {/* Feedback */}
            <textarea
              className="w-full border rounded-md p-2 text-sm mb-4"
              placeholder="Write your feedback..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />

            {/* Actions */}
            <div className="flex justify-end gap-2">
              <button
                className="px-4 py-2 bg-gray-200 rounded"
                onClick={() => {
                  setShowModal(false);
                  navigate("/qwiz/homepage");
                }}
              >
                Skip
              </button>
              <button
  className={`px-4 py-2 ${rating === 0 ? 'bg-gray-300' : 'bg-[#F07404]'} text-white rounded`}
  disabled={rating === 0}
  onClick={handleSubmitFeedback}
>
  Submit
</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PlayGameFrame;
